import Navigation from "../components/Navigation";
import Paginator from "../components/Paginator";

export default class PageSearch {
  constructor() {
    this.data = null;
    this.relatedArticles = [];
    this.paginator = null;
    this.template = "";
    this.postsPerPage = 0;
    this.searchForm = null;
    this.paginatorWrapperClass = ".js-cards-container";
  }

  init(data) {
    this.searchForm = document.querySelector(".search-form");
    this.searchForm.addEventListener(
      "submit",
      this._checkSearchValue.bind(this)
    );
    //Controllo il valore di data

    if (!data) {
      console.warn("No data was provided", data);
      try {
        this._showNoResultsFound();
      } catch (exception) {
        console.error(
          "There was an error, the component couldn't get rendered.",
          exception
        );
      }
      return;
    }

    this.data = data;

    //istanzio il paginator
    this._initPaginator();
    
    if (location.href.includes("?s=") && data && data.length > 0) {
      const paginatorWrapper = document.querySelector(
        this.paginatorWrapperClass
      );

      const timeout = setTimeout(() => {
        const lastChild = paginatorWrapper.children[paginatorWrapper.children.length - 1];
        const header = document.querySelector('.js-site-header');
        window.scrollTo({
          top: lastChild.offsetTop - header.offsetHeight - 10,
          behavior: "smooth",
          left: 0,
        });
        clearTimeout(timeout);
      }, 10);
    }
  }

  _initPaginator() {
    this.paginator = new Paginator(
      null,
      null,
      this.data,
      false,
      this.postsPerPage
    );
    this.paginator.template = this.template;
    this.paginator.wrapperClass = this.paginatorWrapperClass;
    this.paginator.init();
    if(this.data && this.data.length > 0){
      this.paginator.onClickLoadMore();
    }
  }

  //Se non ci sono risultati mostro un componente
  _showNoResultsFound() {
    const noResultsComponent = document
      .getElementById("template-search-nores")
      .cloneNode(true);
    noResultsComponent.id = "";
    const mainContentComponent = document.querySelector(".main-content");

    mainContentComponent.append(noResultsComponent);
  }

  /**
   * Controlla che non ci siano errori nel campo di ricerca e viene richiamato l'evento submit della form, in caso contrario .
   * @param {*} event evento di submit del form
   */
  _checkSearchValue(event) {
    event.preventDefault();
    const searchText = this.searchForm.querySelector("#search");
    if (!searchText) {
      console.error("Component not found", searchText);
      return;
    }

    searchText.style.border = "0";
    if (!searchText.value || searchText.value === "") {
      console.warn("Search text is null or empty", searchText.value);
      searchText.style.border = "1px solid red";
      const errorField = this.searchForm.querySelector(".js-error-search");
      if (!errorField) {
        console.error("Component not found", errorField);
      }
      errorField.innerText = "Campo obbligatorio!";
      return;
    }
    this.searchForm.submit();
  }
}
